import { AIButtonReset } from './AIButtonReset.js'

window.customElements.define('ai-button-reset', AIButtonReset)
